import Helper from "../Helper";
import BaseModal from "./BaseModal";

/**
 * This class represents responsive and desktop draggable modals.
 */
export default class FullscreenModal extends BaseModal {
	/**
	 *
	 * @param {String} modalName the name of modal
	 * @param {Number} width width of modal
	 * @param {Number} height height of modal
	 * @param {Number} scrollHeightDesktop scroll height for desktop
	 * @param {Function | undefined} afterHideCallback called after modal is fully hidden
	 */
	constructor(
		modalName,
		width,
		height,
		scrollHeightDesktop,
		afterHideCallback = undefined
	) {
		super();
		this.$modal = $('[data-fullscreen-modal="' + modalName + '"]');
		this.heightElement = this.$modal.find("[data-heightelement]");
		this.$dim = $('[data-dim="fullscreen-modal"]');
		this.$close = $('[data-close="fullscreen-' + modalName + '"]');
		this.$scrollablePart = $('[data-scroll="fullscreen-' + modalName + '"]');
		this.$notScrollableElements = $(
			'[data-fullscreen-not-scrollable-elements="' + modalName + '"]'
		);
		this.scrollableHeight = 0;
		this.modalName = modalName;
		this.isOpened = false;
		this.isReseting = false;
		this.modalHeight = height;
		this.modalWidth = width;
		this.scrollHeightDesktop = scrollHeightDesktop;
		this.actualHeight = 0;
		this.desktopPadding = 34;

		this.afterHideCallback = afterHideCallback;
		this.initModal();
	}

	/**x
	 * This function initialize the modal.
	 */
	initModal() {
		/**
		 * On window resize update init height
		 */
		window.windowResizeObserve.register(() => {
			this.reset();
		});

		this.$dim.click(() => {
			if (this.$dim.hasClass("active")) {
				this.hide();
			}
		});

		this.$close.click(() => {
			this.hide();
		});

		// On animation end
		this.$modal.on("transitionend", () => {
			// If modal was opened
			if (this.isOpened) {
				if (this.completeCallback) {
					this.completeCallback();
				}
			} else {
				if(this.afterHideCallback !== undefined)
					this.afterHideCallback();
			}
		});
	}

	/**
	 * Opens the modal.
	 *
	 * @param {Function | undefined } beforeCallback calls before opening
	 * @param {Function | undefined } completeCallback calls when opening is complete
	 */
	open(beforeCallback = undefined, completeCallback = undefined) {
		if (!this.isOpened) {
			this.$modal.addClass("active");
			this.$dim.addClass("active");

			$("body").css("overflow", "hidden");

			this.setScrollableAndActualHeight();

			if (Helper.isBigMobileOrLower()) {
				if(beforeCallback !== undefined)
					beforeCallback();

				this.completeCallback = completeCallback;

				this.$modal.addClass("active-mobile");

				this.$modal.css({
					transform: "translateY(0px)",
					left: 0,
					"max-width": "unset",
					"max-height": "unset",
				});

				this.$scrollablePart.css({
					"min-height": this.scrollableHeight + "px",
					"max-height": this.scrollableHeight + "px",
				});

			} else {
				this.$modal.addClass("active-desktop");
				let top = window.innerHeight / 2 - this.actualHeight / 2;
				this.$modal.css({
					left: window.innerWidth / 2 - this.modalWidth / 2,
					transform: "translateY(" + top + "px)",
					bottom: "unset",
					"max-width": this.modalWidth + "px",
					"max-height": this.modalHeight + "px",
				});

				this.$scrollablePart.css({
					"min-height": "unset",
					"max-height": this.scrollHeightDesktop + "px",
				});
			}

			this.isOpened = true;
		}
	}

	/**
	 * Will reset opened modal.
	 */
	reset() {
		this.isReseting = true;

		if (this.isOpened) {
			$("body").css("overflow", "hidden");

			this.setScrollableAndActualHeight();

			if (Helper.isBigMobileOrLower()) {
				if (this.$modal.hasClass("active-desktop")) {
					this.$modal.removeClass("active-desktop");
					this.$modal.addClass("active-mobile");
				}

				this.$scrollablePart.css({
					"min-height": this.scrollableHeight + "px",
					"max-height": this.scrollableHeight + "px",
				});

				this.$modal.css({
					left: 0,
					transform: "translateY(0px)",
					"max-width": "unset",
					"max-height": "unset",
					bottom: "0",
				});
			} else {
				if (this.$modal.hasClass("active-mobile")) {
					this.$modal.removeClass("active-mobile");
					this.$modal.addClass("active-desktop");

					this.$scrollablePart.css({
						"min-height": "unset",
						"max-height": this.scrollHeightDesktop + "px",
					});
				}

				let top = window.innerHeight / 2 - this.actualHeight / 2;

				this.$modal.css({
					left: window.innerWidth / 2 - this.modalWidth / 2,
					transform: "translateY(" + top + "px)",
					bottom: "unset",
					"max-width": this.modalWidth + "px",
					"max-height": this.modalHeight + "px",
				});
			}
		}
	}

	/**
	 * Hides the modal.
	 */
	hide() {
		this.$modal.removeClass("active");

		$("body").css("overflow", "scroll");

		this.$modal.css("transform", "");

		if (Helper.isBigMobileOrLower()) {
			this.$modal.removeClass("active-mobile");
			this.$dim.removeClass("active");
		} else {
			this.$modal.removeClass("active-desktop");
			this.$modal.css({
				"max-width": this.modalWidth + "px",
				"max-height": this.modalHeight + "px",
			});

			setTimeout(() => {
				this.$dim.removeClass("active");
				this.$modal.css({
					bottom: "0px",
				});
			}, 100);
		}

		this.isOpened = false;
	}

	/**
	 * Checks if the respo search modal is opened.
	 *
	 * @returns {boolean}
	 */
	isModalOpened() {
		return this.isOpened;
	}

	/**
	 * Top position of modal relative to screen
	 *
	 * @returns {Number}
	 */
	getTopPosition() {
		return this.$modal.offset().top - $(window).scrollTop();
	}

	/**
	 * Function that counts and sets scrollable height
	 */
	setScrollableAndActualHeight() {
		this.scrollableHeight = 0;

		this.$notScrollableElements.each((i, e) => {
			this.scrollableHeight += $(e).outerHeight();
		});

		this.actualHeight =
			this.scrollableHeight +
			this.heightElement.outerHeight(true) +
			this.desktopPadding;
		this.scrollableHeight = window.innerHeight - this.scrollableHeight - 16;
	}
}
